import { Expose, Type } from 'class-transformer';
import { CreditUsageUserDto } from './credit-usage-user.dto';
import { CreditUsageAllocDto } from './credit-usage-alloc.dto';
import { CreditUsagePaymentDto } from './credit-usage-payment.dto';
import { CreditUsageResourceDto } from './credit-usage-resource.dto';
import { CreditUsageItem } from '../../../../store/CreditsManagement/creditsManagementTypes';

export class CreditUsageListResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'order_type' })
  orderType: string;
  @Expose({ name: 'bill_provider' })
  billProvider: string;
  @Expose({ name: 'item_id' })
  itemId: number;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'sum' })
  sum: number;
  @Expose({ name: 'category_id' })
  categoryId: number;
  @Expose({ name: 'sub_category_id' })
  subCategoryId: number;
  @Expose({ name: 'pdf_url' })
  pdfUrl: string;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'date' })
  date: string;
  @Expose({ name: 'payments' })
  @Type(() => CreditUsagePaymentDto)
  payments: CreditUsagePaymentDto[];
  @Expose({ name: 'user' })
  @Type(() => CreditUsageUserDto)
  orderedBy: CreditUsageUserDto;
  @Expose({ name: 'item' })
  @Type(() => CreditUsageAllocDto)
  item?: CreditUsageItem;
  @Expose({ name: 'resource' })
  @Type(() => CreditUsageResourceDto)
  resource: CreditUsageResourceDto;
}
